import { render, staticRenderFns } from "./FormStepsIndicator.vue?vue&type=template&id=741b4851&scoped=true"
import script from "./FormStepsIndicator.vue?vue&type=script&lang=js"
export * from "./FormStepsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741b4851",
  null
  
)

export default component.exports